import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Showimage from "./showimage";

const modalshowimageslice = ({
  isOpen,
  header,
  onCancel,

  message,
  list,
  size = "xl",
}) => {
  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={onCancel}
        size={size}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <ModalHeader></ModalHeader>
        <ModalBody>
          <Showimage showSlide={true} imagelist={list} />
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={onCancel}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default modalshowimageslice;
